import { useState } from "react";
import SideBar from "./SideBar";
import { Outlet } from "react-router-dom";

const DashboardLayout = () => {
  const [railNav, setRailNav] = useState(false);

  return (
    <div
      className={`dashboard_view relative max-[991px]:flex-wrap flex relative`}
    >
      <SideBar SideBar={(state) => setRailNav(state)} />
      <div className="min-[991px]:pl-[50px] w-full">
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardLayout;
